export default "__VITE_ASSET__DBH7Fqhv__"